const MESSAGES = {
  ERROR: {
    DEFAULT: 'Something went wrong',
    NO_DATA_FOUND: 'No data found',
    LOGIN: 'Something went wrong',
    REGISTER: 'Something went wrong',
    RESETFAIL: 'Email not found',
    SELLERCONNECTEDFAIL: 'please check your credentials, we are not able to connect.'
  },
  SUCCESS: {
    DEFAULT: 'SUCCESS',
    LOGIN: 'Logged in successfully',
    REGISTER: 'Registration successfully',
    RESETSUCCESS: 'Reset password link shared to your email.',
    SELLERCONNECTED: 'Seller account linked successfully.',
    FETCHEDINPROCESS: 'Please wait for few minutes, we are fetching your products.',
    STORECREATEDSUCCESS: 'Store Created Successfully',
    STOREUPDATEDSUCCESS: 'Store Updated Successfully',
    PROFILEPICTUREUPLOAD: 'Profile Picture Upload successfully',
    PAYMENTSUCCESSFULL: 'Thanks for choosing our plan, Please setup the store details.',
    UPGRADEPLANSUCCESS: 'Your Plan Upgrade Successfully',
    CANCELPLANSUCCESS: 'Your Plan Cancelled Successfully',
    RESUMEPLANSUCCESS: 'Your Plan Resume Successfully',
    KEYWORDTRACKINGAVAIALABLE: 'Keyword Tracking is now available'
  }
};

export default MESSAGES;
